import Button from "../../../../../components/button/button";
import { FiEdit, FiTrash } from "react-icons/fi";
import InputSearch from "../../../../../components/inputs/inputSearch/inputSearch";
import { useEffect, useRef, useState } from "react";
import Table from "../../../../../components/table/table";
import { getApiInstance } from "../../../../../utils/api";
import Popup from "../../../../../components/popup/popup";
import Notification from "../../../../../components/notification/notification";
import Modal from "../../../../../components/modal/modal";
import Input from "../../../../../components/inputs/input/input";
import InputDropdownSimple from "../../../../../components/inputs/inputDropdownSimple/inputDropdownSimple";
import { useMemo } from "react";
import { searchByKeywords } from "../../../../../utils/searchUtils";


export const Empresas = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [empresas, setEmpresas] = useState([]);
    const [tiposDeEmpresa, setTiposDeEmpresa] = useState([]); // Aquí almacenaremos los tipos de empresa
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [empresaAEliminar, setEmpresaAEliminar] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const notificationRef = useRef(null);
    const [nombreError, setNombreError] = useState("");
    const [tipoEmpresaError, setTipoEmpresaError] = useState("");
    const [monedas, setMonedas] = useState([]);
    const [filteredEmpresas, setFilteredEmpresas] = useState([]);

    const [newEmpresa, setNewEmpresa] = useState({
        nombre: "",
        codEmpresa: "",
        tipoEmpresa: "",
        moneda: "N/A",
    });

    const openModal = () => {
        setSelectedEmpresa(null);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedEmpresa(null);
        setNewEmpresa({
            nombre: "",
            codEmpresa: "",
            tipoEmpresa: "",
            moneda: "N/A",
        });
    };

    useEffect(() => {
        fetchEmpresas();
        fetchTiposDeEmpresa();
        fetchMonedas();
    }, []);

    const fetchEmpresas = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get("/api/Empresa/GetAllEmpresas");
            console.log("empresasa", response.data);
            const arrayTransformado = response.data.map((item) => ({
                value: item.codEmpresa,
                label: item.nombre,
                cantidadUsuarios: item.usuarios ? item.usuarios.length : 0,
                tipoEmpresa: item.tipoEmpresa || "Administrador",
                moneda: item.moneda || "Sin asignar",
            }));
            setEmpresas(arrayTransformado);
        } catch (error) {
            console.error("Error al obtener las empresas:", error);
            setEmpresas([]);
        }
    };

    const fetchTiposDeEmpresa = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get("/api/Empresa/GetAllTiposEmpresa");
            setTiposDeEmpresa(response.data);
        } catch (error) {
            console.error("Error al obtener los tipos de empresa:", error);
            setTiposDeEmpresa([]);
        }
    };

    const fetchMonedas = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get("/api/Moneda/GetAllMonedas");
            const monedasTransformadas = response.data.map((moneda) => ({
                value: moneda.codMoneda,
                label: moneda.nombreMoneda,
            }));
            setMonedas(monedasTransformadas);
        } catch (error) {
            console.error("Error al obtener las monedas:", error);
            setMonedas([]);
        }
    };

    const handleEditEmpresa = (empresa) => {
        setSelectedEmpresa(empresa);
        setNewEmpresa({
            nombre: empresa.label,
            codEmpresa: empresa.value,
            tipoEmpresa: empresa.tipoEmpresa,
            moneda:empresa.moneda
        });
        setIsModalOpen(true);
    };

    const confirmDeleteEmpresa = (empresa) => {
        if (!empresa.value) {
            console.error(
                "La empresa seleccionada no tiene 'codEmpresa'.",
                empresa
            );
            return;
        }

        setEmpresaAEliminar({
            codEmpresa: empresa.value,
            nombre: empresa.label,
        });
        setIsPopupOpen(true);
    };

    const actions = (row) => [
        {
            label: "Editar",
            onClick: () => handleEditEmpresa(row),
            icon: <FiEdit />,
        },
        {
            label: "Eliminar",
            onClick: () => confirmDeleteEmpresa(row),
            icon: <FiTrash />,
        },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewEmpresa((prevEmpresa) => ({
            ...prevEmpresa,
            [name]: value,
        }));
    };

    const handleConfirmDelete = async () => {
        if (!empresaAEliminar || !empresaAEliminar.codEmpresa) {
            console.error(
                "Error: No hay empresa seleccionada para eliminar",
                empresaAEliminar
            );
            return;
        }

        const api = getApiInstance();
        try {
            console.log(
                `Intentando eliminar empresa con ID: ${empresaAEliminar.codEmpresa}`
            );
            const response = await api.delete(
                `/api/Empresa/${empresaAEliminar.codEmpresa}`
            );

            console.log("Respuesta de eliminación:", response);

            setEmpresas((prevEmpresas) =>
                prevEmpresas.filter(
                    (empresa) => empresa.value !== empresaAEliminar.codEmpresa
                )
            );

            notificationRef.current.addNotification(
                `La empresa ${empresaAEliminar.nombre} ha sido eliminada con éxito.`,
                "success"
            );
        } catch (error) {
            console.error(
                "Error al eliminar la empresa:",
                error.response?.data || error.message
            );
            notificationRef.current.addNotification(
                `Error al eliminar la empresa: ${
                    error.response?.data?.message || "Error desconocido"
                }`,
                "error"
            );
        }

        setIsPopupOpen(false);
    };

    const handleAddEmpresa = async () => {
        setNombreError("");
        setTipoEmpresaError("");

        if (!newEmpresa.nombre) {
            setNombreError("El campo nombre es obligatorio.");
            return;
        }

        if (!newEmpresa.tipoEmpresa) {
            setTipoEmpresaError("El campo tipo empresa es obligatorio.");
            return;
        }

        const empresaToSubmit = {
            codEmpresa: newEmpresa.codEmpresa || 0,
            nombre: newEmpresa.nombre,
            codTipoEmpresa: newEmpresa.tipoEmpresa.value,
            codMoneda: newEmpresa.moneda.value,
        };

        const api = getApiInstance();
        try {
            if (selectedEmpresa) {
                await api.put(
                    `/api/Empresa/${selectedEmpresa.value}`,
                    empresaToSubmit
                );
                setEmpresas((prevEmpresas) =>
                    prevEmpresas.map((empresa) =>
                        empresa.value === selectedEmpresa.value
                            ? {
                                  ...empresa,
                                  label: empresaToSubmit.nombre,
                                  tipoEmpresa: empresaToSubmit.tipoEmpresa,
                                  moneda: empresaToSubmit.moneda,
                              }
                            : empresa
                    )
                );
                notificationRef.current.addNotification(
                    `Empresa ${empresaToSubmit.nombre} actualizada con éxito.`,
                    "success"
                );
            } else {
                const response = await api.post(
                    "/api/Empresa",
                    empresaToSubmit
                );
                setEmpresas((prevEmpresas) => [
                    ...prevEmpresas,
                    {
                        value: response.data.codEmpresa,
                        label: response.data.nombre,
                        tipoEmpresa: response.data.tipoEmpresa,
                        moneda: response.data.moneda,
                    },
                ]);
                notificationRef.current.addNotification(
                    "Empresa añadida con éxito.",
                    "success"
                );
            }

            await fetchEmpresas();
            closeModal();
        } catch (error) {
            console.error("Error al añadir o editar empresa:", error);
            notificationRef.current.addNotification(
                "Error al añadir o editar empresa.",
                "warning"
            );
        }
    };

    const columnsEmpresas = [
        { key: "", label: "" },
        { key: "cantidadUsuarios", label: "Usuarios" },
        { key: "label", label: "Nombre" },
        { key: "tipoEmpresa", label: "Tipo Empresa" },
        { key: "moneda", label: "Moneda" }
    ];
    
    useEffect(() => {
    const campos = ["label", "cantidadUsuarios", "tipoEmpresa", "moneda"];
    const resultado = searchByKeywords(empresas, searchTerm, campos);
    setFilteredEmpresas(resultado);
}, [empresas, searchTerm]);

    // const filteredEmpresas = useMemo(() => {
    //     return empresas.filter((empresa) =>
    //         Object.values(empresa).some((value) =>
    //             value ? value.toString().toLowerCase().includes(searchTerm.toLowerCase()) : false
    //         )
    //     );
    // }, [searchTerm, empresas]);
    
    return (
        <>
            <div className="dashboard-usuarios__content__table-header">
                <InputSearch
                    context="tableSearch"
                    placeholder="Buscar..."
                    onSearch={setSearchTerm}
                />

                <div className="dashboard-usuarios__content__table-header__buttons">
                    <Button
                        label="Añadir empresa"
                        variant="filled"
                        onClick={openModal}
                    />
                </div>
            </div>

            <Table
                columns={columnsEmpresas}
                data={filteredEmpresas} 
                actions={actions}
                showHeaderCheckbox={false}
                noResultsMessage="No se ha encontrado ningún resultado."
            />

            <Modal
                title={selectedEmpresa ? "Editar Empresa" : "Añadir Empresa"}
                isOpen={isModalOpen}
                onClose={closeModal}
                onAccept={handleAddEmpresa}
            >
                <div className="dashboard-usuarios__modal">
                    <form
                        className="dashboard-usuarios__modal__content"
                        autoComplete="off"
                    >
                        <Input
                            type="text"
                            label="Nombre"
                            name="nombre"
                            value={newEmpresa.nombre}
                            placeholder="Introduce el nombre de la empresa"
                            onChange={handleInputChange}
                        />

                        {nombreError && <p className="error">{nombreError}</p>}

                        <InputDropdownSimple
                            label="Tipo de empresa"
                            placeholder="Selecciona tipo de empresa"
                            options={tiposDeEmpresa.map((tipo) => ({
                                value: tipo.codTipoEmpresa,
                                label: tipo.tipo,
                            }))}
                            value={newEmpresa.tipoEmpresa}
                            onSelect={(selectedOption) => {
                                setNewEmpresa((prev) => ({
                                    ...prev,
                                    tipoEmpresa: selectedOption,
                                }));
                            }}
                        />

                        {tipoEmpresaError && (
                            <p className="error">{tipoEmpresaError}</p>
                        )}

                        <InputDropdownSimple
                            label="Moneda"
                            placeholder="Selecciona una moneda"
                            options={monedas}
                            value={newEmpresa.moneda}
                            onSelect={(selectedOption) => {
                                setNewEmpresa((prevEmpresa) => ({
                                    ...prevEmpresa,
                                    moneda: selectedOption,
                                }));
                            }}
                        />
                    </form>
                </div>
            </Modal>

            <Notification ref={notificationRef} />

            {isPopupOpen && (
                <Popup
                    type="alert"
                    alertType="warning"
                    titleMessage="Confirmar eliminación"
                    alertMessage={`¿Estás seguro de que deseas eliminar la empresa ${empresaAEliminar.nombre}?`}
                    onConfirm={handleConfirmDelete}
                    onClose={() => setIsPopupOpen(false)}
                    confirmLabel="Eliminar"
                    cancelLabel="Cancelar"
                />
            )}
        </>
    );
};
